import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"

import moment from "moment"
import {transactionTypes, getTransaction} from "~/utils/ShelfEntities"
import {
  List,
  DetailInfoRow,
  ListItemArticle,
  ListItemLocation
} from "~/components/"
import {withTranslation} from "react-i18next"

class TransactionDetailView extends ComponentWithData {
  getData() {
    const urlParams = this.props.match.params
    return getTransaction(urlParams.transaction_id, urlParams.transaction_type)
  }

  renderLoading = () => <p>{this.props.t("loading")}</p>
  renderError = () => (
    <p>
      {this.props.t("error")} {this.state.error}
    </p>
  )
  renderEmpty = () => <p>{this.props.t("transactions.noTransactions")}</p>

  renderWithData() {
    const transaction = this.state.data
    const date = moment(transaction.created_at).format("D.M.YYYY – H:mm")
    const transactionTypeData = transactionTypes(this.props.t)[
      transaction.transaction_type
    ]

    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">
            {this.props.t("transactions.detail.title")}
          </div>
        </div>
        <div>
          <DetailInfoRow
            label={this.props.t("transactions.detail.type")}
            value={transactionTypeData.name}
          />
          <DetailInfoRow
            label={this.props.t("transactions.detail.date")}
            value={date}
          />
          <DetailInfoRow
            label={this.props.t("transactions.detail.user")}
            value={transaction.user.email}
          />
          <DetailInfoRow
            label={this.props.t("transactions.detail.quantity")}
            value={transaction.quantity}
          />
          <DetailInfoRow
            label={this.props.t("transactions.detail.note")}
            value={transaction.note}
          />

          <DetailInfoRow label={this.props.t("transactions.detail.article")}>
            <List
              items={[transaction.article]}
              itemRenderer={ListItemArticle}
              itemDisableActions
            >
              <div className="empty">
                {this.props.t("transactions.detail.articleNotFound")}
              </div>
            </List>
          </DetailInfoRow>

          {transaction.previous_version && (
            <DetailInfoRow
              label={this.props.t("transactions.detail.previousVersion")}
              value={transaction.previous_version}
            />
          )}
          {transaction.next_version && (
            <DetailInfoRow
              label={this.props.t("transactions.detail.nextVersion")}
              value={transaction.next_version}
            />
          )}
          {transaction.previous_location && (
            <React.Fragment>
              <DetailInfoRow
                label={this.props.t("transactions.detail.fromLocation")}
              >
                <List
                  items={[transaction.previous_location]}
                  itemRenderer={ListItemLocation}
                  itemDisableActions
                />
              </DetailInfoRow>
            </React.Fragment>
          )}
          {transaction.location && (
            <DetailInfoRow
              label={
                transaction.transaction_type === "Movement"
                  ? this.props.t("transactions.detail.toLocation")
                  : this.props.t("transactions.detail.location")
              }
            >
              <List
                items={[transaction.location]}
                itemRenderer={ListItemLocation}
                itemDisableActions
              />
            </DetailInfoRow>
          )}
        </div>
      </div>
    )
  }
}

export default withTranslation()(TransactionDetailView)



// WEBPACK FOOTER //
// ./src/views/detail/TransactionDetailView.js